module.exports = __webpack_public_path__ + "static/media/to-start-page.3450a46c.svg";